<template>
  <div class="h-screen bg-neutral-light-50 dark:bg-neutral-dark-900 dark:text-neutral-dark-200">
    <div class="h-full max-w-full overflow-auto">
      <NuxtPage />
    </div>
  </div>
</template>
